import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../../App';
import OrderHeader from '../../Order/OrderHeader/OrderHeader';
import DropDown from './DropDown';

const OrderListAdmin = () => {
    const [orderList, setOrderList] = useState([])
    const [loggedInUser, setLoggedInUser] = useContext(UserContext)
    useEffect(() => {
        fetch('https://assignment-11-samiun.herokuapp.com/order?email=' + loggedInUser.email)
        .then(res => res.json())
        .then(data => setOrderList(data))
    }, [loggedInUser.email, orderList])
    return (
        <div className="row">
            <div className="col-md-2">
                <OrderHeader />
            </div>
            <div className="col-md-10 mt-4">
                <h3 className="mb-2">Order List</h3>
                <div style={{background: '#F4F7FC', height: '100vh'}}>
          <div className="p-4 container" style={{background: 'white', height: '100vh'}}>
          <div className="row pt-3 ps-2 " style={{background: 'whitesmoke', borderRadius: '10px'}}>
              <p className="col-md-3">Name</p>
              <p className="col-md-3">Email ID</p>
              <p className="col-md-3">Service</p>
              <p className="col-md-3">Status</p>
          </div>
          <div className="row ">
              <div className="mt-3 col-md-3">
                  {
                      orderList.map(order => <p className="mb-5">{order.displayName}</p>)
                  }
              </div>
              <div className="mt-3 col-md-3">
                  {
                      orderList.map(order => <p className="mb-5">{order.email}</p>)
                  }
              </div>
              <div className="mt-3 col-md-3">
                  {
                      orderList.map(order => <p className="mb-5">{order.title}</p>)
                  }
              </div>
              <div className="col-md-3 mt-3" >
                  {
                      orderList.map(order => <DropDown order={order}/>)
                  }
              </div>
          </div>  
          </div>
        </div>
                </div>
            </div>
    );
};

export default OrderListAdmin;